module.exports = __webpack_public_path__ + "img/login_bj.c452d32c.png";